import React from "react";
import { motion } from "framer-motion";
import { Lightbulb, Activity, CheckCircle, Users, Briefcase, Stamp } from "lucide-react";
import { useEffect, useState } from "react";



const pastelColors = [
  "bg-[#c3dafe]",
  "bg-[#b3d4fc]",
  "bg-[#a8cfff]",
  "bg-[#bae0ff]",
  "bg-[#c0dbff]",
  "bg-[#d0e4ff]",
  "bg-[#abd9ff]",

];

const titles = [
  "Ayvalık Marin",
  "YENİLİKÇİ VE GÜVENİLİR",
  "SÜREKLİ GELİŞEN ÜRETİM",
  "GÜVEN VE GARANTİ",
  "MÜŞTERİ ODAKLILIK",
  "PROFESYONEL EKİP",
  "CE BELGELİ ÜRETİM"
];

const icons = [
  <Lightbulb size={34} className="text-[#002744]" />,
  <Activity size={34} className="text-[#002744]" />,
  <CheckCircle size={34} className="text-[#002744]" />,
  <Users size={34} className="text-[#002744]" />,
  <Briefcase size={34} className="text-[#002744]" />,
  <Stamp size={34} className="text-[#002744]" />,
];

const nelerYapiyoruzTitles = [
  "",
  "Projeli tekne motoryat üretimi",
  "Tekne bakım onarım boyama hizmetleri",
  "Elektrik ve Sıhhi tesisat işlemleri",
  "Motor montajı",
  "Kışlama ve Romörk taşıma hizmetleri",
];


const nelerYapiyoruzContents = [
  "",
  "Firmamız, projeye özel Polyester, Fiber ve Ahşap tekneler ile motoryatlar üretmektedir. Müşteri taleplerine göre şekillenen üretim sürecimizde, estetik ve dayanıklılığı bir araya getiriyor; her tekneyi titizlikle tasarlayıp hayata geçiriyoruz. Deneyimli ekibimizle, özgün tasarımlarınızı güvenli ve konforlu deniz araçlarına dönüştürüyoruz.",
  "Teknenizin ömrünü uzatmak ve performansını korumak için bakım, onarım ve boyama hizmetleri sunuyoruz. Polyester, fiber ve ahşap teknelerde uzman ekibimizle detaylı kontroller yapıyor, ihtiyaç duyulan tüm işlemleri titizlikle gerçekleştiriyoruz. Estetik ve teknik yenilemelerle teknenizi ilk günkü görünümüne kavuşturuyoruz.",
  "Teknenizin tüm elektrik ve sıhhi tesisat ihtiyaçlarını profesyonel çözümlerle karşılıyoruz. Aydınlatma sistemlerinden temiz su tesisatına kadar her detay, güvenlik ve dayanıklılık önceliğiyle uygulanır. Denizde konforunuzu artırmak için tüm donanımlar titizlikle monte edilir ve test edilir.",
  "Teknenizin performansı için en uygun motor montajı hizmetini sunuyoruz. Seçilen motorun tekneye uyumlu şekilde montajı, bağlantıların kontrolü ve test süreçleri uzman ekibimiz tarafından titizlikle gerçekleştirilir. Güvenli, verimli ve uzun ömürlü kullanım için her aşamada kaliteyi ön planda tutuyoruz.",
  "Teknenizin mevsim koşullarından etkilenmemesi için kışlama ve römork ile taşıma hizmetleri sunuyoruz. Güvenli taşıma, uygun saklama koşulları ve düzenli kontrollerle teknenizi koruma altına alıyor; sezona sorunsuz başlamanızı sağlıyoruz. Her süreç profesyonel ekip ve uygun ekipmanlarla yürütülür."
];
const contents = [
  "Teknede yaşam, kimileri için denizle iç içe bir hayat tarzı, kimileri için ise sınırsız mavilikte özgürlükle buluşmanın bir yoludur. Dalgaların ritmi, deniz havasının ferahlığı ve açık denizlerin sunduğu huzur, teknede geçirilen zamanları benzersiz kılar. Bu eşsiz deneyimden aldığımız ilhamla, biz de Ayvalık Marin olarak sadece tekne üretmiyor; insanların denizle kurduğu bağı daha anlamlı ve özel kılacak yaşam alanları tasarlıyoruz. Amacımız, her detayı özenle düşünülmüş, estetik, dayanıklı ve fonksiyonel teknelerle, deniz tutkunlarının hayallerini gerçeğe dönüştürmek.",
  "Modern üretim altyapımız ve sektörel tecrübemiz sayesinde, estetik ve işlevselliği bir araya getiren yüksek kaliteli tekneler üretiyoruz. Yenilikçi yaklaşımımızla, hem tasarım hem de üretim süreçlerinde çağın ihtiyaçlarına uygun çözümler sunuyoruz. Güvenilirliğimiz, her üründe kaliteyi ve müşteri memnuniyetini ön planda tutmamızdan kaynaklanır.",
  "Üretim anlayışımızı, Ar-Ge çalışmaları ve müşteri geri bildirimleriyle geliştiriyoruz. Her modelde kullanıcı deneyimini artıracak yenilikçi çözümler sunarak, ürünlerimizi bugünün ve geleceğin ihtiyaçlarına uygun hale getiriyoruz. Bu sayede sektörel değişimlere hızla uyum sağlıyor, kalite ve müşteri memnuniyetini daima ön planda tutuyoruz.",
  "Ürettiğimiz her tekne, üretimin her aşamasında titizlikle denetlenir; teslimat öncesi uygulanan kapsamlı testlerle güvenli, dayanıklı ve yüksek performanslı olması sağlanır. Müşterilerimize yalnızca bir ürün değil, uzun ömürlü ve sorunsuz bir deniz deneyimi sunmayı taahhüt ediyoruz. Güven ve garanti, üretim anlayışımızın temel taşlarını oluşturur.",
  "Müşterilerimizin beklenti ve ihtiyaçlarını merkeze alarak, her kullanım amacına uygun, konforlu ve estetik tekneler tasarlıyoruz. Kullanıcı deneyimini ön planda tutarak, sadece bir ürün değil, aynı zamanda hayalleri gerçeğe dönüştüren özel yaşam alanları sunuyoruz. Müşteri memnuniyeti, tüm üretim sürecimizin temelini oluşturur.",
  "Üretim sürecimiz, alanında sertifikalı ve deneyimli uzmanlar tarafından titizlikle yürütülmektedir. Ekibimiz, en güncel üretim teknolojilerini yakından takip ederek süreçlerimize entegre eder. Bu sayede yüksek kalite, güvenilirlik ve verimlilik standartlarını sürekli olarak koruruz.",
  "CE belgesi, Avrupa Birliği'nin yeni yaklaşım direktiflerine uygun ürünlere verilen ve AB pazarında satılabilmesi için zorunlu olan bir işarettir. Bu işaret, ürünün AB standartlarına uyduğunu gösterir ve ürünün Avrupa’da serbestçe dolaşabilmesini sağlar. Bir anlamda ürünün Avrupa pazarı için pasaportu gibidir.",

];

const SevenBlocksContainer = () => {
  const [isMobile, setIsMobile] = useState(false);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth < 1020); 
  };

  handleResize(); // ilk çalıştırma
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

  return (
    <div className="bg-[#ebd7b4] text-center">
      <div className="mb-12 text-center">
        <h2 className="text-4xl md:text-6xl font-bold opacity-20 text-black font-righteous">
          AYVALIK MARİN
        </h2>
        <h3 className="text-4xl font-semibold text-black -mt-1 font-montserrat">
          NEDEN BİZ?
        </h3>
      </div>
      <section className="w-full py-2 px-6 flex justify-center items-center pb-14 overflow-hidden">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl w-full">
          {Array.from({ length: 6 }, (_, i) => (
            <motion.div
              key={i}
              className={`relative ${
                pastelColors[i + 1]
              }  text-black p-6 rounded-md shadow-[0_4px_8px_rgba(0,0,0,0.2)] hover:shadow-xl transition-all duration-300 cursor-pointer transform hover:scale-110  flex flex-col items-center text-center`}
              style={{
                rotate: isMobile ? "0deg" : i % 2 === 0 ? "2.5deg" : "-2.5deg"
              }}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
              viewport={{ once: true }}
            >
              {/* Bant Efekti */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-20 h-4 bg-red-300 rounded-b-md shadow-sm z-10" />
              {icons[i] && (
              <img
                src={`images/icons/seven_section_icon${i + 1}.png`}
                alt="icon"
                className="w-20 h-20"
              />
              )}
              <div className="relative z-20">
                <h3 className="text-lg font-bold mb-2 font-montserrat text-center">
                  {titles[i + 1]}
                </h3>
                <p className="text-sm text-gray-800 text-center leading-relaxed">
                  {contents[i + 1]}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      <div className="mb-12 text-center">
        <h2 className="text-4xl md:text-6xl font-bold opacity-20 text-black font-righteous">
          AYVALIK MARİN
        </h2>
        <h3 className="text-4xl font-semibold text-black -mt-1 font-montserrat">
          NELER YAPIYORUZ?
        </h3>
      </div>

      <section className="w-full py-2 px-6 flex justify-center items-center pb-4 md:pb-14 overflow-hidden">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl w-full">
          {Array.from({ length: 3 }, (_, i) => (
            <motion.div
              key={i + 1}
              className={`relative ${
                pastelColors[i + 2]
              } text-black p-6 rounded-md shadow-[0_4px_8px_rgba(0,0,0,0.2)] hover:shadow-xl transition-all duration-300 cursor-pointer transform hover:scale-110 flex flex-col items-center text-center`}
              style={{
              rotate: isMobile ? "0deg" : i % 2 === 0 ? "2.5deg" : "-2.5deg"
            }}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              viewport={{ once: true }}
            >
              {/* Bant Efekti */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-20 h-4 bg-red-300 rounded-b-md shadow-sm z-10" />
              <img
                src={`images/icons/icon${i + 1}.png`}
                alt="icon"
                className="w-20 h-20"
              />
              <h3 className="text-lg font-bold mb-2 text-gray-900 font-montserrat">
                {nelerYapiyoruzTitles[i + 1]}
              </h3>
              <p className="text-sm text-black">
                {nelerYapiyoruzContents[i + 1]}
              </p>
            </motion.div>
          ))}
        </div>
      </section>

<section className="w-full py-2 px-6 flex justify-center items-center pb-20 overflow-hidden">
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 max-w-4xl w-full">
    {Array.from({ length: 2 }, (_, i) => (
      <motion.div
        key={i + 3}
        className={`relative ${
          pastelColors[i + 4]
        } text-black p-6 rounded-md shadow-[0_4px_8px_rgba(0,0,0,0.2)] hover:shadow-xl transition-all duration-300 cursor-pointer transform hover:scale-110 flex flex-col items-center text-center`}
        style={{
          rotate: isMobile ? "0deg" : i % 2 === 0 ? "2.5deg" : "-2.5deg"
        }}
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: (i + 3) * 0.1 }}
        viewport={{ once: true }}
      >
        {/* Bant Efekti */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-20 h-4 bg-red-300 rounded-b-md shadow-sm z-10" />
        <img
          src={`images/icons/icon${i + 4}.png`}
          alt="icon"
          className="w-20 h-20 mb-4"
        />
        <h3 className="text-lg font-bold mb-2 text-gray-900 font-montserrat lg:whitespace-nowrap">
          {nelerYapiyoruzTitles[i + 4]}
        </h3>
        <p className="text-sm text-black mb-4">
          {nelerYapiyoruzContents[i + 4]}
        </p>
      </motion.div>
    ))}
  </div>
</section>

    </div>
  );
};

export default SevenBlocksContainer;
